import {v4 as uuidv4} from 'uuid';
import {getEnv} from '../../common/env/env';
import {ContentHomeAboutVo} from '../../common/shared/api/nicolas/vo/ContentHomeAboutVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {ContentHomeAbout, Maybe, User} from '../generated/types';
import {createAuthor} from './Author';
import {createCharacter} from './Character';
import {createContentDetail} from './ContentDetail';
import {createContentHomeDetailInfoList} from './ContentHomeDetailInfoList';
import {createThemeKeyword} from './ThemeKeyword';

export function createContentHomeAbout(
  userInfo: Maybe<User>,
  {
    author_list,
    description,
    detail,
    screen_shot_list,
    theme_keyword_list,
    guide_title,
    character_list,
  }: ContentHomeAboutVo
): ContentHomeAbout {
  return {
    id: uuidv4(),
    authorList: author_list ? author_list.map(createAuthor) : [],
    description,
    detail: detail && createContentDetail(detail),
    screenshotList: screen_shot_list
      ? screen_shot_list.map(url => {
          return url.startsWith('http')
            ? url
            : getKageUrl({
                kageUrlPrefix: getEnv().kageUrlPrefix,
                kageId: url,
                resolution: 'th3',
              });
        })
      : [],
    themeKeywordList: theme_keyword_list
      ? theme_keyword_list.map(createThemeKeyword)
      : [],
    guideTitle: guide_title,
    characterList: character_list ? character_list?.map(createCharacter) : [],
    detailInfoList: createContentHomeDetailInfoList({author_list, detail}),
  };
}
